import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCsPunishList = async (params: object) => {
  return await GET({
    url: Api.queryCsPunishList,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
